import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors} from '@angular/forms';
import {AppConfigService} from '../../core/services/app-config.service';
import {ValidatorResult} from './validator-result';
import {AppConstants} from '../utils/app-constants';

@Directive({
  selector: '[appPasswordStrengthValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: PasswordStrengthValidatorDirective, multi: true}]
})
export class PasswordStrengthValidatorDirective {

  @Input() technicalUser = false;

  validate(c: AbstractControl): ValidationErrors | null {
    const password: string = c.value;

    if (!password) {
      return null;
    }

    const passwordPolicy = this.technicalUser ? AppConfigService.settings.passwordPolicy.technicalUser : AppConfigService.settings.passwordPolicy.normalUser;

    if (password.length < passwordPolicy.minLength) {
      return {passwordTooShort: new ValidatorResult(AppConstants.VALIDATORS_PREFIX + 'passwordTooShort', {minLength: passwordPolicy.minLength})};
    }

    if (((password).match(/[!@#$%^&*(),.?":{}|<>]/g) || []).length < passwordPolicy.specialCharacters) {
      return {passwordNotValid: this.getValidatorResult(passwordPolicy)};
    }

    if (((password).match(/[A-Z]/g) || []).length < passwordPolicy.uppercaseCharacters) {
      return {passwordNotValid: this.getValidatorResult(passwordPolicy)};
    }

    if (((password).match(/[a-z]/g) || []).length < passwordPolicy.lowercaseCharacters) {
      return {passwordNotValid: this.getValidatorResult(passwordPolicy)};
    }

    if (((password).match(/[0-9]/g) || []).length < passwordPolicy.digits) {
      return {passwordNotValid: this.getValidatorResult(passwordPolicy)};
    }

    return null;
  }

  private getValidatorResult(passwordPolicy): ValidatorResult {
    return new ValidatorResult(AppConstants.VALIDATORS_PREFIX + 'passwordNotValid', {
      minSpecialChars: passwordPolicy.specialCharacters,
      minUpperCase: passwordPolicy.uppercaseCharacters,
      minLowerCase: passwordPolicy.lowercaseCharacters,
      minDigits: passwordPolicy.digits
    });
  }

}
